// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1rW_t","list":"PatternAutocomplete_list__3Pfc4"};